import React from 'react';
import clsx from 'clsx';

type SkeletonProps = React.HTMLAttributes<HTMLDivElement>;

/**
 * Base Skeleton Component
 *
 * This component creates a placeholder loading state that can be used
 * while content is being fetched or rendered.
 *
 * @param {Object} props - The properties passed to the component
 * @param {string} [props.className] - Additional CSS classes to apply to the skeleton
 * @param {...React.HTMLAttributes<HTMLDivElement>} props - Any other valid HTML div attributes
 */
export function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      className={clsx('bg-darker-gray/50 animate-pulse rounded-xl', className)}
      {...props}
    />
  );
}

export type { SkeletonProps };
